





















































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator"
import { AwEventStore } from "@/models/AwEventStore"
import { AwEventType } from "@/models/AwEventType"
import { SubtitleUrls } from "@/models/SubtitleUrls"
import { EventBus } from "@/event-bus"
import { formatDate } from "@/services/DurationFormatter"
import mergeSubtitles from "@/services/mergeSubtitles"
const shaka = require("shaka-player/dist/shaka-player.ui")
import addCaptionButton from "../VideoPlayerComponents/CaptionButton"
import replaceclass from "@/services/replaceClass"
import "shaka-player/dist/controls.css"
import "@/assets/plyr.css"
import "@/assets/captions.css"
import "@/assets/volume_slider.css"
import { LanguageList } from "@/models/LanguageList"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
import { VideoInfo } from "@/models/VideoInfo"
import { isIOS, isMobile } from "@/services/deviceDetection"
import { FullVideoData } from "@/models/FullVideoData"
@Component
export default class VideoPlayer extends Vue {
  @Prop({ default: 640 }) private width!: number
  @Prop() private video_urls!: VideoInfo
  @Prop() private duration!: string
  @Prop() private subtitleUrls?: SubtitleUrls
  @Prop() private subtitles?: SubtitleUrls[]
  @Prop({ default: false }) private isgated!: boolean
  @Prop({ default: -1 }) private mid!: number
  @Prop({ default: 0 }) private continuefromTime!: number
  get video(): HTMLVideoElement {
    return this.$el.getElementsByTagName("video")[0] as HTMLVideoElement
  }
  get isGated(): boolean {
    return this.isgated && this.$root.$data.isGated
  }
  get subtitleArray(): SubtitleUrls[] {
    return mergeSubtitles(
      this.subtitleUrls,
      this.isContinued
        ? this.$root.$data.fullVideoInfo.subtitles
        : this.subtitles
    )
  }
  isContinued: boolean = false
  get moment_id(): number {
    return this.isContinued ? -1 : this.mid
  }
  get defaultSubtitleArray(): SubtitleUrls[] {
    return this.needDefaultCaptions ? this.subtitleArray : []
  }

  get showEndScreen() {
    return (
      this.hasVideoEnded &&
      this.moment_id != -1 &&
      this.$root.$data.fullVideoInfo.isReady &&
      this.continuefromTime > 0
    )
  }
  get isNotMobile() {
    return !isMobile(navigator.platform, navigator.maxTouchPoints)
  }
  get posterCaptions(): SubtitleUrls[] {
    return this.subtitleArray
      .filter(x => x.language != "en")
      .filter((x, i) => i < 5)
  }
  get captionDropDownHeight(): number {
    return this.subtitleArray.length > 2
      ? 3 * 27 + 40
      : (this.subtitleArray.length + 1) * 27 + 40
  }
  get areVideoURLsDefined(): boolean {
    return !!this.video_info.dash_url && !!this.video_info.hls_url
  }
  get volumeHolder(): HTMLElement {
    return this.$refs.volume_bar as HTMLElement
  }
  get volumeSeekBar(): HTMLInputElement {
    return this.$refs.volume_slider as HTMLInputElement
  }
  get video_info(): VideoInfo {
    return this.isContinued
      ? this.$root.$data.fullVideoInfo.video_urls
      : this.video_urls
  }
  get continue_text(): string {
    return isIOS(navigator.platform, navigator.maxTouchPoints)
      ? "Watch full video"
      : "Continue playing"
  }
  captionButton?: HTMLElement
  btnWidth = 0
  volume_range_height = 0
  volume = 1
  volumeSeekTimer = 0
  volumeRightMargin = 0
  captionTooltipPos = 0
  volumeLevel = 1
  showError = false
  errorPosterHeight = 0
  shakaPlayer?: any
  gateDivHeight = 0
  start = 0
  isposter = true
  hasVideoEnded = false
  durationElement?: HTMLElement
  playbuttonElement?: HTMLElement
  bottomControlElement?: HTMLElement
  skimElement?: HTMLElement
  seekbarelement?: HTMLElement
  seekbarbufferedelement?: HTMLElement
  shakacontrolsContainerElement?: HTMLElement
  event?: AwEventStore
  needDefaultCaptions = false
  timeout?: number
  dur = formatDate(this.duration)
  captionScrollTimer = 0
  currentCaptions = "off"
  ismounted = false
  videoWidth = 0
  _analytics = container.resolve(AnalyticsClient)
  @Watch("volume", { immediate: true })
  updateVolume(val: number) {
    if (!this.ismounted) return
    this.volumeLevel = val
    this.video.volume = val
    val == 0 ? (this.video.muted = true) : (this.video.muted = false)
  }
  init() {
    this.volume_range_height = this.volumeHolder
      ? this.volumeHolder.clientHeight * 0.85
      : 0
    this.errorPosterHeight = this.$el
      ? (this.$el as HTMLElement).clientWidth * 0.56
      : 0
    this.videoWidth = this.$el ? (this.$el as HTMLElement).clientWidth : 0
  }
  public mounted() {
    const self = this
    this._analytics = container.resolve(AnalyticsClient)
    this.ismounted = true
    EventBus.$on("carouselSetupCompleted", this.init)
    this.init()
    if (!this.video_info.poster_url)
      this.$root.$data.logger.error(
        `Parmonic Widget Error: Video Poster missing {posterUrl: ${this.video_info.poster_url}}`
      )
    if (this.isGated && !this.video_info.poster_url) {
      this.showErrorPoster()
      return
    }
    if (!this.areVideoURLsDefined) {
      this.$root.$data.logger.error(
        `Parmoinic Widget Error: Video Urls missing { dashUrl:${this.video_info.dash_url} , hlsUrl:${this.video_info.hls_url}}`
      )
      this.showErrorPoster()
      return
    }
    if (this.isGated) {
      ;(this.$refs.poster as HTMLImageElement).onload = () => {
        this.gateDivHeight = (this.$refs
          .poster as HTMLImageElement).clientHeight
      }
      return
    }

    this.video.onended = function () {
      self.hasVideoEnded = true
      if (!self.showEndScreen) EventBus.$emit("videoEnded")
      self.updateSeekbar()
    }
    this.$root.$data.videoPlayers.push(this.video)
    if (!shaka.Player.isBrowserSupported()) {
      this.video.src = this.video_info.dash_url
      return
    }
    setTimeout(this.loadPlayer, 500)
  }
  loadPlayer() {
    shaka.polyfill.installAll()
    this.shakaPlayer = new shaka.Player(this.video)
    // For more Shaka Player options, see: https://github.com/google/shaka-player
    this.shakaPlayer.configure({
      abr: {
        defaultBandwidthEstimate: 16000000 // 2 MB/s or 1.6e+7 bits/s
      },
      playRangeStart: this.$root.$data.time_data.startTime
        ? parseFloat(this.$root.$data.time_data.startTime)
        : 0,
      playRangeEnd: this.$root.$data.time_data.endTime
        ? parseFloat(this.$root.$data.time_data.endTime)
        : Infinity,
      streaming: {
        jumpLargeGaps: true,
        bufferingGoal: 20,
        failureCallback: (err: any) => {
          this.$root.$data.logger.error(`Video Buffering failed::${err}`)
        }
      }
    })
    this.loadVideo()
  }
  async loadVideo(endTime: number = 0) {
    this.removeUI()
    if (isIOS(navigator.platform, navigator.maxTouchPoints)) {
      // We're most likely on iOS. Shaka 2.5 will switch to native HLS
      this.needDefaultCaptions = true
      this.shakaPlayer
        .load(this.video_info.hls_url)
        .then(() => {
          if (endTime > 0) {
            this.video.play()
          }
        })
        .catch(async (error: any) => {
          if (/InvalidStateError/i.test(error)) {
            this.$root.$data.logger.warn(
              "Parmonic Widget Warning: State Error occured reloading video"
            )
            await this.loadVideo()
            return
          } else {
            this.$root.$data.logger.error(
              `Parmonic Widget Error: Loading hls url failed: ${error}`
            )
          }
        })
      const uiConfig = {
        controlPanelElements: [
          "play_pause",
          "time_and_duration",
          "mute",
          "fullscreen"
        ],
        addSeekBar: true
      }
      const ui = new shaka.ui.Overlay(
        this.shakaPlayer,
        this.$refs.shaka_container,
        this.video
      )
      ui.configure(uiConfig)
      const controls = ui.getControls()
      controls
        .getControlsContainer()
        .getElementsByClassName("shaka-seek-bar-container")[0]
        .classList.add("is-on-iphone")
      this.loadUI(controls)
    } else {
      //this loads dash
      this.shakaPlayer
        .load(this.video_info.dash_url)
        .then(() => {
          // It loaded successfully
          if (this.subtitleArray.length > 0) {
            this.subtitleArray.forEach(subtitleUrls => {
              this.shakaPlayer.addTextTrack(
                subtitleUrls.web_vtt_url,
                subtitleUrls.language ? subtitleUrls.language : `en`,
                "subtitles",
                "text/vtt",
                undefined,
                subtitleUrls.language ? subtitleUrls.language : `en`
              )
            })
          }
          // Factory that will create the caption button at run time.
          addCaptionButton(this.shakaPlayer, shaka)
          const uiConfig =
            this.subtitleArray.length > 0
              ? {
                  controlPanelElements: [
                    "play_pause",
                    "time_and_duration",
                    "mute",
                    "captions",
                    "fullscreen"
                  ],
                  addSeekBar: true
                }
              : {
                  controlPanelElements: [
                    "play_pause",
                    "time_and_duration",
                    "mute",
                    "fullscreen"
                  ],
                  addSeekBar: true
                }
          const ui = new shaka.ui.Overlay(
            this.shakaPlayer,
            this.$refs.shaka_container,
            this.video
          )
          ui.configure(uiConfig)
          const controls = ui.getControls()
          controls
            .getControlsContainer()
            .getElementsByClassName("shaka-seek-bar-container")[0]
            .classList.add("not-on-iphone")
          this.loadUI(controls)
          //Todo:add check for duration out of bound
          if (endTime > 0) {
            this.video.currentTime = endTime
            this.video.play()
          }
        })
        .catch(async (error: any) => {
          if (/InvalidStateError/i.test(error)) {
            this.$root.$data.logger.warn(
              "Parmonic Widget Warning: State Error occured reloading video "
            )
            await this.loadVideo()
            return
          } else {
            this.$root.$data.logger.error(
              `Parmonic Widget Error: Loading dash url failed: ${error}`
            )
            this.showErrorPoster()
          }
        })
    }
    this.video.addEventListener("play", this.onPlay)
    this.video.addEventListener("pause", this.onPause)
    var self = this
    this.video.onprogress = function () {
      self.updateLoadedIndicator()
    }
  }
  removeUI() {
    var shaka_container = this.$refs.shaka_container as HTMLElement
    Array.from(shaka_container.children).forEach(el => {
      if (
        el.classList.contains(`shaka-controls-container`) ||
        el.classList.contains(`shaka-spinner-container`)
      ) {
        shaka_container.removeChild(el)
      }
    })
  }
  clickCaption(cap: string, play: boolean = false) {
    if (play) this.video.play()
    if (!this.shakaPlayer) return
    this.currentCaptions = cap
    if (cap == `off`) {
      this.shakaPlayer.setTextTrackVisibility(false)
      if (this.captionButton) {
        replaceclass(
          this.captionButton,
          `shaka-caption-on`,
          `shaka-caption-off`
        )
      }
      return
    }
    var subtitle = Array.from(this.shakaPlayer.getTextTracks()).filter(
      (x: any) => x.language == cap
    )
    if (!subtitle[0]) {
      this.$root.$data.logger.error("Error: could not load subtitles")
      return
    }
    this.shakaPlayer.selectTextTrack(subtitle[0])
    this.shakaPlayer.setTextTrackVisibility(true)
    if (this.captionButton) {
      replaceclass(this.captionButton, `shaka-caption-off`, `shaka-caption-on`)
    }
  }
  loadUI(controls: any) {
    if (controls) {
      this.shakacontrolsContainerElement = controls.getControlsContainer() as HTMLElement
      this.loadDuration(controls.getControlsContainer() as HTMLElement)
      this.playbuttonElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-play-button-container"
      )[0] as HTMLElement
      if (this.playbuttonElement) {
        if (
          this.playbuttonElement.getElementsByClassName(`shaka-play-button`)[0]
        )
          this.playbuttonElement
            .getElementsByClassName(`shaka-play-button`)[0]
            .setAttribute("type", "button")
      }
      this.bottomControlElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-bottom-controls"
      )[0] as HTMLElement
      this.skimElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-skim-container"
      )[0] as HTMLElement
      this.seekbarelement = document.createElement("div")
      this.seekbarelement.classList.add("shaka-seek")
      this.seekbarbufferedelement = document.createElement("div")
      this.seekbarbufferedelement.classList.add("shaka-seek-buffered")
      ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-seek-bar-container"
      )[0] as HTMLElement).appendChild(this.seekbarelement)
      ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-seek-bar-container"
      )[0] as HTMLElement).appendChild(this.seekbarbufferedelement)
      this.bottomControlElement.classList.add("hide")
      Array.from(
        this.bottomControlElement.getElementsByClassName(
          "shaka-controls-button-panel"
        )[0].children
      ).forEach(element => {
        if (element.tagName == "BUTTON") {
          element.setAttribute("type", "button")
        }
      })
      this.skimElement.classList.add("hide")
      this.shakacontrolsContainerElement.classList.add("opaque")
      this.loadVolumeBar(this.shakacontrolsContainerElement)
    }
    this.loadcaptions(this.$el as HTMLElement)
    let fs = this.$el.getElementsByClassName(`shaka-fullscreen-button`)
    let isfs =
      fs.length > 0
        ? fs[0].classList.contains("shaka-hidden")
          ? false
          : true
        : false
    this.volumeRightMargin = this.captionButton
      ? isfs
        ? 58
        : 30
      : isfs
      ? 28
      : 2
    this.captionTooltipPos = isfs ? 43 : 72
    if (this.$root.$data.autoPlay) this.video.play()
  }
  loadcaptions(container: HTMLElement) {
    this.captionButton = container.getElementsByClassName(
      `shaka-caption-button`
    )[0] as HTMLElement
    if (this.captionButton) {
      if (!isMobile(navigator.platform, navigator.maxTouchPoints))
        this.captionButton.onmouseover = this.showCaptions
      this.captionButton.onclick = this.showCaptions
      this.captionButton.onmouseout = this.offCaptionsHover
    }
  }
  loadVolumeBar(container: HTMLElement) {
    if (isMobile(navigator.platform, navigator.maxTouchPoints)) return
    let shakaMuteButton = container.getElementsByClassName(
      "shaka-mute-button"
    )[0] as HTMLElement
    if (!shakaMuteButton) return
    let self = this
    shakaMuteButton.onmouseover = this.showVolume
    shakaMuteButton.onmouseout = this.offVolumeHover
    shakaMuteButton.onclick = function () {
      if (self.video.muted) {
        self.volumeLevel = 0
      } else {
        self.volumeLevel = self.volume
      }
    }
  }
  loadDuration(container: HTMLElement) {
    this.durationElement = document.createElement("div")
    this.durationElement.textContent = formatDate(this.duration)
    this.durationElement.classList.add("parmonic-video-duration")
    this.durationElement.classList.add("show")
    container.appendChild(this.durationElement)
  }
  onRePlay() {
    this.video.play()
  }
  onContinuePlay() {
    this.video.onprogress = null
    //reload the player
    this.isContinued = true
    this.resetPlayer(this, this.continuefromTime)
  }
  onPlay() {
    this.hasVideoEnded = false
    this.$root.$data.videoPlayers.forEach((player: any) => {
      if (player != this.video) {
        player.pause()
      }
    })
    if (isMobile(navigator.platform, navigator.maxTouchPoints)) {
      replaceclass(this.$refs.caption_drop_down as HTMLElement, `show`, `hide`)
    }
    if (this.$root.$data.eventElement) {
      const ev = new Event("play")
      this.$root.$data.eventElement.dispatchEvent(ev)
    }
    setTimeout(() => {
      let w = (this.$el.getElementsByClassName(
        "shaka-caption-button"
      )[0] as HTMLElement)
        ? 28
        : 0
      this.btnWidth = (this.$el.getElementsByClassName(
        "shaka-current-time"
      )[0] as HTMLElement)
        ? (this.$el.getElementsByClassName(
            "shaka-current-time"
          )[0] as HTMLElement).getBoundingClientRect().width + w
        : w
    }, 100)
    EventBus.$emit("playing-Video", this.moment_id)
    this.start = this.video.currentTime
    //hide poster on play
    this.isposter = false
    //hide duration on play
    replaceclass(this.durationElement, "show", "hide")
    //hide play button on 1stplay
    if (this.playbuttonElement) {
      this.playbuttonElement.classList.add("hide")
    }
    //show bottom controls on play
    replaceclass(this.bottomControlElement, "hide", "show")
    replaceclass(this.skimElement, "hide", "show")
    replaceclass(this.shakacontrolsContainerElement, "opaque", "")
    this.timeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
  }
  onPause() {
    if (this.$root.$data.eventElement) {
      const ev = new Event("pause")
      this.$root.$data.eventElement.dispatchEvent(ev)
    }
    if (isMobile(navigator.platform, navigator.maxTouchPoints)) {
      replaceclass(this.$refs.caption_drop_down as HTMLElement, `show`, `hide`)
    }
    clearTimeout(this.timeout)
    if (this.moment_id > -1) {
      this.event = {
        eventType: AwEventType.MomentPlayed,
        momentId: this.mid,
        start: Math.floor(this.start),
        end: Math.ceil(this.video.currentTime)
      }
      this._analytics.register(this.event, this.$root.$data.identifierKey)
    } else {
      this.event = {
        eventType: AwEventType.WebinarPlayed,
        start: Math.floor(this.start),
        end: Math.ceil(this.video.currentTime)
      }
      this._analytics.register(this.event, this.$root.$data.identifierKey)
    }
  }
  updateLoadedIndicator() {
    if (this.seekbarbufferedelement && this.video.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${
          ((this.video.buffered.end(0) - this.video.currentTime) /
            this.video.duration) *
          100
        }% !important`
      )
    }
  }
  updateSeekbar() {
    clearTimeout(this.timeout)
    if (this.seekbarelement) {
      let diff = parseFloat(this.$root.$data.time_data.startTime) || 0
      this.seekbarelement.setAttribute(
        "style",
        `width:${
          ((this.video.currentTime - diff) / (this.video.duration - diff)) * 100
        }% !important`
      )
    }
    if (this.seekbarbufferedelement && this.video.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${
          ((this.video.buffered.end(0) - this.video.currentTime) /
            this.video.duration) *
          100
        }% !important`
      )
    }
    this.timeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
  }
  clickGate() {
    EventBus.$emit("gate-event")
  }
  onCaptionHover() {
    clearTimeout(this.captionScrollTimer)
  }
  offCaptionsHover() {
    if (isMobile(navigator.platform, navigator.maxTouchPoints)) return
    this.captionScrollTimer = setTimeout(this.hideCaptions, 200)
  }
  showCaptions() {
    this.hideVolume()
    clearTimeout(this.captionScrollTimer)
    ;(this.$refs.caption_drop_down as HTMLElement).classList.contains(`hide`)
      ? replaceclass(
          this.$refs.caption_drop_down as HTMLElement,
          `hide`,
          `show`
        )
      : replaceclass(
          this.$refs.caption_drop_down as HTMLElement,
          `show`,
          `hide`
        )
  }
  hideCaptions() {
    clearTimeout(this.captionScrollTimer)
    replaceclass(this.$refs.caption_drop_down as HTMLElement, `show`, `hide`)
  }
  onVolumeHover() {
    clearTimeout(this.volumeSeekTimer)
  }
  offVolumeHover() {
    this.volumeSeekTimer = setTimeout(this.hideVolume, 200)
  }
  hideVolume() {
    clearTimeout(this.volumeSeekTimer)
    replaceclass(this.$refs.volume_bar as HTMLElement, `show`, `hide`)
  }
  showVolume() {
    this.hideCaptions()
    clearTimeout(this.volumeSeekTimer)
    replaceclass(this.$refs.volume_bar as HTMLElement, `hide`, `show`)
  }
  getLanguageString(index: keyof typeof LanguageList) {
    return LanguageList[index]
  }
  public beforeMount() {
    window.addEventListener("resize", this.init)
    if (this.$root.$data.eventElement) {
      let self = this
      this.$root.$data.eventElement.addEventListener(
        "ReloadPlayer",
        async function (evt: any) {
          self.$root.$data.time_data.startTime = evt.detail.startTime
            ? evt.detail.startTime
            : self.$root.$data.time_data.startTime
          self.$root.$data.time_data.endTime = evt.detail.endTime
            ? evt.detail.endTime
            : self.$root.$data.time_data.endTime
          self.resetPlayer(self)
        }
      )
    }
  }
  public beforeDestroy() {
    window.removeEventListener("resize", this.init)
  }
  showErrorPoster() {
    if (this.shakaPlayer) this.shakaPlayer.destroy()
    this.init()
    this.showError = true
  }
  async resetPlayer(self: any, startTime: number = 0) {
    clearTimeout(self.timeout)
    if (self.shakaPlayer) {
      var shaka_container = self.$refs.shaka_container as HTMLElement
      let shakaarray = Array.from(shaka_container.children)
      for (let i = 0; i < shakaarray.length; i++) {
        let el = shakaarray[i]
        if (el.classList.contains(`shaka-controls-container`)) {
          await shaka_container.removeChild(el)
        }
      }
      await self.shakaPlayer.detach()
      await self.shakaPlayer.attach(self.video)
      await self.loadVideo(startTime)
    }
  }
}
